interface ViewSummaryButtonProps {
    onClick: any;
}

function ViewSummaryButton({ onClick }: ViewSummaryButtonProps) {
    // Checklist SVG icon component  
    const ChecklistIcon = () => (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.668 2.66634H12.0013C12.3549 2.66634 12.6941 2.80682 12.9441 3.05687C13.1942 3.30691 13.3346 3.64605 13.3346 3.99967V13.333C13.3346 13.6866 13.1942 14.0258 12.9441 14.2758C12.6941 14.5259 12.3549 14.6663 12.0013 14.6663H4.0013C3.64768 14.6663 3.30854 14.5259 3.05849 14.2758C2.80844 14.0258 2.66797 13.6866 2.66797 13.333V3.99967C2.66797 3.64605 2.80844 3.30691 3.05849 3.05687C3.30854 2.80682 3.64768 2.66634 4.0013 2.66634H5.33464M8.0013 7.33301H10.668M8.0013 10.6663H10.668M5.33464 7.33301H5.3413M5.33464 10.6663H5.3413M6.0013 1.33301H10.0013C10.3695 1.33301 10.668 1.63148 10.668 1.99967V3.33301C10.668 3.7012 10.3695 3.99967 10.0013 3.99967H6.0013C5.63311 3.99967 5.33464 3.7012 5.33464 3.33301V1.99967C5.33464 1.63148 5.63311 1.33301 6.0013 1.33301Z"
                stroke="#111827"
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );

    return (
        <button
            onClick={onClick}
            className="flex items-center space-x-2 px-4 py-2 text-gray-700 transition-colors"
            style={{
                borderRadius: '6px',
                border: '1px solid #E2E8F0',
                background: '#FFF'
            }}
        >
            <ChecklistIcon />
            <span>View Summary</span>
        </button>
    );
}

export default ViewSummaryButton;
